define('components/decorators/datev-autosuggest',[
    'jquery',
    'components/util/clearbutton',
    'lib/select2',
    'lib/jquery-ui'
], function($, clearButtonUtil) {

    $.extend(companyInfo.decorators, {

        'datev-autosuggest': function() {


            var param = this.getAttribute('data-param');
            var url = this.getAttribute('data-source');
            var submitOnSelect = this.getAttribute('data-submit-on-select');
            var disableSubmitOnEnter = this.getAttribute('data-disable-submit-on-enter');
            var redirectToURL = this.getAttribute('data-redirect-url');
            var maxResults = this.getAttribute('data-max-results');
            var keepDataFromHiddenField = this.getAttribute('data-keep-hidden-field');
            var lastSearch;
            var input = $(this);
            var form = input.closest("form");
            clearButtonUtil.setClearInputFieldsIcons(form);

            var instance = input.autocomplete({
                source: function(request, response) {
                    var params = {
                        q: request.term
                    };
                    if (maxResults) {
                        params.max = maxResults;
                    }
                    $.ajax({
                        url: url,
                        dataType: 'json',
                        data: params,
                        success: function(data) {
                            var results = [];
                            if (data.query) {
                                lastSearch = data.query;
                            }
                            $.each(data.results, function(result) {
                                results.push(this);
                            });
                            response(results);
                        }
                    });
                },
                focus: function(event, ui) {
                    var val;
                    if (!ui.item.id) {
                        val = lastSearch;
                    } else if (ui.item.attributes.organizationName) {
                        val = ui.item.attributes.organizationName;
                    }
                    input.val(val);
                    return false;
                },
                select: function(event, ui) {
                    var val;
                    if (!ui.item.id) {
                        val = lastSearch;
                    } else if (ui.item.attributes.organizationName) {
                        val = ui.item.attributes.organizationName;
                    }
                    input.val(val);
                    if (input.next().is('input[type=hidden]') && ui.item.id) {
                        input.next().val(ui.item.id);
                    }

                    //if redirectToURL, redirect to this url
                    if(redirectToURL && ui.item.id) {
                      window.location = serviceUtil.createEndPoint(redirectToURL, {"client-id":ui.item.id});
                      return;
                    }

                    if (submitOnSelect) {
                        this.form.submit();
                    }
                    return false;
                }
            }).autocomplete('instance');


            input.keypress(function(e) {
                if (e.keyCode == 13 && (disableSubmitOnEnter === null || disableSubmitOnEnter === 'false')) {
                  $(this).blur();
                  form.submit();
                }
            });

            instance._renderItem = function(ul, item) {
                var li = '<li>';
                if (item.attributes.organizationName) {
                    li += item.attributes.organizationName;
                }
                if (item.city) {
                    li += ' <small>' + item.city + '</small>';
                }
                li += '</li>';
                return $(li).appendTo(ul);
            };

            instance._resizeMenu = function() {
                this.menu.element.outerWidth(input.outerWidth());
            };

            if (input.next().is('input[type=hidden]') && keepDataFromHiddenField != 'yes') {
                input.next().val(''); 
            }
        }

    });

});

